module.exports = __webpack_public_path__ + "static/media/hand.17eb8f2a.svg";